@let o = order();
@let locale = languageService.getCurrentLocale();
@let returned = paymentReturn();

@if (returned?.status === 'approved') {
  <div
    class="pay-result pay-result-success"
    role="status"
  >
    <tc-icon name="check-circle" />
    <div class="pay-result-title">{{ 'payment_options.approved_title' | translate }}</div>
    <div>
      {{ 'payment_options.approved_paid' | translate: { amount: (returned.amount | number:'1.0-2' : locale), orderId: o.id } }}
    </div>
    <div class="pay-result-next">{{ 'payment_options.approved_next' | translate }}</div>
    <a
      class="g-btn pay-result-btn"
      routerLinkWithLang
      [routerLink]="['/', 'account', 'orders']"
    >
      {{ 'payment_options.to_orders' | translate }}
    </a>
  </div>
} @else {
  <div
    class="options"
    [class.options-panel]="layout() === 'panel'"
    [class.options-buttons]="layout() === 'buttons'"
  >
    <ng-template #paymentChoices>
      @if (returned?.status === 'pending') {
        <div
          class="pay-result"
          role="status"
        >
          {{ 'payment_options.pending' | translate }}
        </div>
      }
      <div class="option-online-group">
        <tc-button
          class="option-online"
          [buttonSize]="layout() === 'panel' ? 'large' : 'small'"
          [isLoading]="isPaying()"
          isBold
          (click)="payOnline()"
        >
          <span class="option-online-label">{{ 'payment_options.pay_online' | translate }}</span>
          <span class="option-online-wallets">
            <img
              src="/assets/images/google-pay.svg"
              alt="Google Pay"
            >
            <img
              src="/assets/images/apple-pay.svg"
              alt="Apple Pay"
            >
          </span>
        </tc-button>
        @if (payError(); as error) {
          <div
            class="options-error"
            role="alert"
          >
            {{ error }}
          </div>
        }
      </div>

      <div class="options-or">
        <span>{{ 'payment_options.or' | translate }}</span>
      </div>
    </ng-template>

    @if (layout() === 'panel') {
      @if (cardDetails(); as details) {
        <cmt-card-payment-details [details]="details">
          <ng-container [ngTemplateOutlet]="paymentChoices" />
        </cmt-card-payment-details>
      } @else {
        @if (isCardDetailsLoading()) {
          <preloader class="options-preloader" />
        }
        @if (cardDetailsError(); as error) {
          <div class="options-error">{{ error }}</div>
        }
        <ng-container [ngTemplateOutlet]="paymentChoices" />
      }
    } @else {
      <ng-container [ngTemplateOutlet]="paymentChoices" />
      <a
        class="g-btn g-btn-transparent g-btn-small option-alternative"
        [routerLink]="['/', 'order-payment-details']"
        [queryParams]="{ orderId: o.idExpanded }"
        target="_blank"
        rel="noopener"
        routerLinkWithLang
      >
        <tc-icon name="bank" />
        {{ 'payment_options.pay_by_details' | translate }}
        <tc-icon
          class="option-external"
          name="external-link"
        />
      </a>
    }
  </div>
}
